export const FETCHING = 'FETCHING';
export const FETCHED = 'FETCHED';
export const UPDATED = 'UPDATED';
export const CREATED = 'CREATED';
export const DELETED = 'DELETED';
export const DELETED_MANY = 'DELETED_MANY';
